import React, { Component, Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Form, FormGroup } from 'reactstrap';
import { canCreateAndUpdatePage, canDeletePage, canUserNotPermission, canCreateAnimation, canCreateCommentPublicUser } from '../authorizations';
import { version } from '../util/animation';
import iconBin from '../ui/images/iconBinRed.svg';
import iconBinWhite from '../ui/images/iconBinWhite.svg';
import iconPen from '../ui/images/iconPen.png';
import iconWeb from '/app/assets/images/icon-www.png';
import iconVideo from '/app/assets/images/video_akaire.png';
import iconPDF from '/app/assets/images/upload_image.png';
import compareVersion from '/app/assets/images/compare_version.png';
import iconYoutube from '/app/assets/images/youTube.png';
import imgDefaultThumbnail from '/app/assets/images/default_loading_thumbnail.png';
import imgNoAnimation from '/app/assets/images/no_animation.png';
import bytes from 'bytes';
import "../css/project-info-header.scss";
import Select, { components } from "react-select";

export default class AnimationPlayer extends Component {
  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);
  }

  constructor() {
    super();
    this.url = new URL(location.href);
    this.queryPageId = this.url.searchParams.get("page_id") || this.url.searchParams.get("update_version_page");
    this.state = {
      shouldShowEditForm: false,
      shouldShowAddPageSuccess: false,
      valueForm: '',
      valuePageId: '',
    };
    this.url = new URL(location.href);
    this.mainUrl = this.url.href.split('?')[0];
    this.showPopupAddPage = true
  }

  componentDidMount() {
    // bug#2 対策: 外部からBootstrap側で modal('hide') された時に React state を同期するため
    window._tmClosePageEditModal = () => {
      this.setState({ shouldShowEditForm: false });
    };
  }

  componentWillUnmount() {
    if (window._tmClosePageEditModal) delete window._tmClosePageEditModal;
  }

  componentDidUpdate() {
    if (this.props.currentAnimationTotalSize != NaN) {
      let el_size_current_animation = document.getElementsByClassName('animation_size');

      if (el_size_current_animation.length > 0  && !this.props.currentAnimation?.need_conversion) {
        if(this.props.currentAnimationTotalSize || this.props.currentAnimationTotalSize == 0) {
          el_size_current_animation[0].innerHTML =
            '<div class="animation-size-label">総容量</div><div class="animation-size-value">' +
            bytes(this.props.currentAnimationTotalSize) + '</div>';
        }
        const totalFileSize = document.getElementById('akaire-file-total-file-size');
        if (totalFileSize) {
          totalFileSize.innerHTML = bytes(this.props.currentAnimationTotalSize || 0);
        }
      }
      this.toggleElementList("nav-bar-animation_size", true);
      if(window.innerWidth <= 720) this.appendFileSize()
    }
    this.showPopupWhenAddNewPage();
  }

  showPopupWhenAddNewPage = () => {
    const { pages } = this.props;
    if (!pages.some(_ => _.id == this.queryPageId)) {
      return;
    }
    const addNewpage = this.url.searchParams.get("new_page")
    if(this.props && this.showPopupAddPage && addNewpage == 'true') {
      const { animations } = this.props;
      if(pages.length > 0 && animations.length > 0) {
        this.showPopupAddPage = false
        this.setState({shouldShowAddPageSuccess: true})
      }
    }
  }

  linkOpenEditPage(page) {
    return (
      <a href='javascript:void(0)' className='text-white text-underline'
        onClick={(event) => {
          this.open(event, {label: page.title, value: page.id}); this.closePopupAddPageSuccess()}
        }>ページ名を変更する</a>
    )
  }

  appendFileSize = () => {
    let height = document.querySelector('.bottom-pane')?.offsetTop || 0;

    const controlBar = document.querySelector('.video-react-control-bar');
    const videoReactRoot = controlBar?.closest('.video-react');
    const rect = videoReactRoot?.getBoundingClientRect?.();
    const isFullscreen =
      !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      ) ||
      videoReactRoot?.classList?.contains('video-react-fullscreen') ||
      (!!rect && rect.width >= window.innerWidth - 10 && rect.height >= window.innerHeight - 10);

    const elementAppend = $('.video-react-control-bar').find('.video-react-progress-control')
    if (controlBar) {
      if (isFullscreen) {
        controlBar.style.top = 'auto';
        controlBar.style.bottom = '0';
        controlBar.style.left = '0';
        controlBar.style.right = '0';
        controlBar.style.position = 'absolute';
      } else {
        controlBar.style.top = `${height - 48}px`;
        controlBar.style.bottom = '';
        controlBar.style.left = '';
        controlBar.style.right = '';
        controlBar.style.position = 'fixed';
      }
    }
    if (!!elementAppend) {
      $('.video-react-control.video-react-file-size').remove()
      elementAppend.after(`<div class='video-react-control video-react-file-size'>${bytes(this.props.currentAnimationTotalSize)}</div>`)
    }
  }

  toggleElementList(className, show = true) {
    const elementList = document.getElementsByClassName(className);
    for (let i = 0; i < elementList.length; i++) {
      elementList[i].style.visibility = show ? "visible" : "hidden";
    }
  }

  toggle = bool => name => {
    this.setState({ [`shouldShow${name}`]: bool, valueForm: this.currentPage() && this.currentPage().title })
  }
  open = (event, page) => {
    event.stopPropagation();
    this.setState({
      shouldShowEditForm: true,
      valueForm: page.label,
      valuePageId: page.value
    })
  }
  close = this.toggle(false)
  submitForm = (event) => {
    const { onSubmit } = this.props;
    const { valueForm, valuePageId } = this.state;
    event.preventDefault();
    onSubmit({ title: valueForm, pageId: valuePageId })
      .then(
        this.setState({ shouldShowEditForm: false })
      )
  }
  changeName = (event) => {
    this.setState({
      valueForm: event.target.value
    });
  }
  currentPage = () => {
    const { pages, currentPageId } = this.props;
    return (pages && pages.filter(page => page.id == currentPageId)[0])
  }
  confirmDeletePage = (data) => {
    const { deletePage } = this.props;
    Popup.confirm(
      `<span class="font-weight-bold">${data.label}を削除します。<br>よろしいですか？</span>`,
      {
        success: () => {
          deletePage(data.value, data.label)
        },
        confirmText: 'OK',
        kind: 'akaire'
      }
    )
  }

  confirmDeleteVersion = (value) => {
    const { deleteVersion } = this.props;
    Popup.confirm(
      '<span class="font-weight-bold">このバージョンを削除します。<br>よろしいですか？</span>',
      {
        success: () => {
          deleteVersion(value)
        },
        confirmText: 'OK',
        kind: 'akaire',
      }
    )
  }
  onChangeAnimationSelect = (value) => {
    this.props.selectAnimation(value)
  }

  pagesToOptions = () => {
    const { pages, isOffAllFinalPage } = this.props;
    if (isOffAllFinalPage) {
      const pageFilter = pages.filter(page => !page.is_final_page)
      if (pageFilter.length > 0) {
        return pageFilter.map(({ id, title }) => ({ value: id, label: title }))
      } else {
        return [{ value: '', label: '該当ページはありません。' }]
      }
    } else {
      return pages.map(({ id, title }) => ({ value: id, label: title }))
    }
  }

  animationsToOptions = () => {
    const { animations } = this.props;
    var dataAnimations = animations
    if(this.checkFinalVersion() === undefined) {
      dataAnimations = animations.sort((a, b) => b.id - a.id)
    }

    return dataAnimations.map((animation) => {
      const {
        id,
        title,
        formatted_created_at,
        creator_name,
        final,
        official_name,
        additional_info,
        is_video_embed,
        url,
        set_thumbnail,
        drive_file_status,
        category,
        need_conversion,
      } = animation;

      const keepComment = additional_info?.gdrive_file_status === 'keep_comment';
      const deleted = drive_file_status === 'deleted';
      const fileName = keepComment || deleted ? null : (official_name || additional_info.title || '');
      const duration = keepComment ? null : additional_info.duration;

      return {
        value: id,
        label: final ? '最終稿' : title,
        createdAt: formatted_created_at,
        creatorName: creator_name,
        fileName,
        duration,
        video_embed: is_video_embed,
        video_upload: category === 'video' && !is_video_embed,
        url_capture: additional_info?.gdrive_file ? null : url,
        set_thumbnail: deleted ? imgNoAnimation : set_thumbnail,
        keep_comment: keepComment,
        disabled: need_conversion,
      };
    })
  }

  lastAnimationToOptions = () => {
    var option = this.animationsToOptions();
    return option.slice(-1)[0].value
  }

  sortAnimation = (animations) => {
    const finalObjects = animations.filter(obj => obj.final).sort((a, b) => b.id - a.id);
    const nonFinalObjects = animations.filter(obj => !obj.final).sort((a, b) => b.id - a.id);
    return [...finalObjects, ...nonFinalObjects];
  }

  defaultPage = () => {
    const { pages, currentPageId } = this.props;
    if (currentPageId == undefined) return {}
    const page = pages.find((item) => item.id == currentPageId)
    return { value: page.id, label: page.title }
  }

  defaultVersion = () => {
    const { animations, currentAnimation } = this.props;
    if (currentAnimation == undefined) return {}
    const animation = animations.find((item) => item.id == currentAnimation.id)
    return { value: animation.id, label: animation.final ? '最終稿' : animation.title }
  }

  checkFinalVersion = () => {
    const { animations } = this.props;
    const animationFinal = animations.find((animation) => animation.final === true)
    return animationFinal
  }

  customSelectStyle = (isPage) => {
    let borderStyle = {}
    const { mobile } = this.props
    if (isPage) {
      borderStyle = {
        borderRight: '0px !important',
        borderRadius: '5px 0px 0px 5px',
        border: '2px solid white',
        borderColor: 'white'
      }
    } else {
      borderStyle = {
        borderLeft: '0px !important',
        borderRadius: '0px 5px 5px 0px',
        border: '2px solid white',
        borderColor: 'white'
      }
    }
    const chevronColor = 'white'
    const viewportSideSpace = mobile ? 14 : 16;
    const versionMenuMaxWidth = mobile
      ? `calc(100vw - ${viewportSideSpace * 2}px)`
      : 'min(380px, calc(100vw - 32px))';
    return {
      singleValue: (provided) => ({
        ...provided,
        color: 'white',
        backgroundColor: 'black',
        fontSize: mobile ? '11px' : '',
        top: mobile ? '43%' : '50%',
      }),
      control: (provided, state) => ({
        ...provided,
        ...borderStyle,
        color: 'white',
        backgroundColor: 'black',
        height: mobile ? '28px' : '',
        boxShadow: state.isFocused ? 0 : 0,
        minHeight: mobile ? '28px' : '',
        '&:hover': {
          border: `2px solid ${chevronColor}`,
        }
      }),
      input: (provided) => ({
        ...provided,
        color: 'transparent'
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        color: state.isFocused ? chevronColor : chevronColor,
        marginTop: mobile ? '-7px' : '-3px',
        '&:hover': {
          color: state.isFocused ? chevronColor : chevronColor,
        }
      }),
      option: (provided) => ({
        ...provided,
        backgroundColor: isPage ? '#3C3C3C' : 'white',
        backgroundClip: 'padding-box',
        padding: '0',
        borderBottom: '1px solid white',
        fontWeight: 'normal',
        '&:last-child': {
          border: 'none'
        }
      }),
      menuList: (provided) => ({
        ...provided,
        padding: 0,
        borderRadius: '6px',
      }),
      menu: (provided) => ({
        ...provided,
        borderRadius: '8px',
        border: `2px solid ${isPage ? 'white' : 'black'}`,
        marginTop: mobile ? 0 : 2,
        position: mobile ? 'fixed' : provided.position,
        width: isPage
          ? (mobile ? `calc(100vw - ${viewportSideSpace * 2}px)` : document.getElementById('page-selector').offsetWidth)
          : (mobile ? 'auto' : versionMenuMaxWidth),
        maxWidth: isPage ? '100%' : versionMenuMaxWidth,
        zIndex: '2147483646',
        left: mobile ? `${viewportSideSpace}px` : (isPage ? '' : 'auto'),
        right: mobile ? `${viewportSideSpace}px` : (isPage ? '' : '0'),
        top: mobile ? (gon.is_login ? '64px' : '70px') : 'auto',
        marginLeft: 0,
        marginRight: 0,
        overflow: 'hidden',
      }),
    }
  }

  handleOutSideClick = (e) => {
    this.setState({ shouldShowEditForm: false })
  }

  closePopupAddPageSuccess = () => {
    const { akaireFileId } = this.props;
    history.pushState({}, '', akaireFileId);
    this.setState({ shouldShowAddPageSuccess: false })
  }

  onChangePageSelf = (event) => {
    const { onChangePage, role, isOffAllFinalPage } = this.props;
    if (isOffAllFinalPage && event.value === '') return
    onChangePage(event)
    if (canUserNotPermission(role) || role === 'reader') return
    if (this.selectAnimationRef) {
      setTimeout(() => {
        this.selectAnimationRef.select.focus()
        this.selectAnimationRef.onMenuOpen(() => true)
      }, 1200);
    }
  }

  onCheckCompareVersion = (version_id) => {
    var checkedOption = $('.checkbox-compare:checked')
    if(checkedOption.length == 0) {
      $('.button-compare-version').addClass('disabled')
    } else if(checkedOption.length > 0 && checkedOption.length <= 2) {
      $('.button-compare-version').removeClass('disabled')
    } else if(checkedOption.length > 2) {
      $(`.checkbox-compare[value=${version_id}]`).prop('checked', false)
      $('.alert-more-than-two-option').removeClass('d-none')
      setTimeout(() => {
        $('.alert-more-than-two-option').addClass('d-none')
      }, 3000);
    }
  }

  submitCompareVersion = () => {
    const { akaireFileId, currentPageId } = this.props;
    const checkedOption = $('.checkbox-compare:checked')
    const animations = this.animationsToOptions()
    if(checkedOption.length == 1) {
      if(this.checkIsCompareScreen()) {
        window.location.href = Routes.akaire_feature_akaire_file_path(akaireFileId, { page_id: currentPageId, animation_id: checkedOption.attr('value')})
      } else {
        const value = animations.find((item) => item.value.toString() == checkedOption.attr('value'))
        this.props.selectAnimation(value)
        this.selectAnimationRef.setState({menuIsOpen: false,})
      }
    } else if(checkedOption.length == 2) {
      // FIX 20260811-comparemedia 種類の違うメディア同士を2画面で並べると、動画・YouTubeにしか
      //   存在しないタイムラインがPDF側にも現れる等の表示崩れが起きるため、比較させない。
      //   判定は既にバージョン一覧が持っている情報(video_embed / video_upload)だけで行い、
      //   通信は一切増やさない。種別が違う場合は画面を切り替えず、その場で案内のみ出す。
      //   同じ種別どうしの比較・1件選択時の動作・チェックの上限2件は一切変更していない。
      //   分類は画面のアイコン表示(versionTypeIcon)と全く同じ順序・同じ基準で行い、
      //   PDFと画像だけはファイル名の拡張子で分ける。判定は画面が既に持つ情報のみを使う。
      const __kindOf = (v) => {
        const a = animations.find((item) => item.value.toString() == v.toString())
        if (!a) return 'unknown'
        if (a.video_embed) return 'youtube'
        if (a.video_upload) return 'video'
        if (a.url_capture !== null && a.url_capture !== undefined) return 'web'
        const __ext = String(a.fileName || '').split('.').pop().toLowerCase()
        return __ext === 'pdf' ? 'pdf' : 'image'
      }
      const __k1 = __kindOf(checkedOption[0].value)
      const __k2 = __kindOf(checkedOption[1].value)
      if (__k1 !== 'unknown' && __k2 !== 'unknown' && __k1 !== __k2) {
        if (window.Popup && typeof window.Popup.alert === 'function') {
          window.Popup.alert('異なる種類のメディアは<br>2画面で比較できません。', '', '', { kind: 'akaire', duration: 5000 })
        }
        return
      }
      window.location.href = Routes.compare_version_akaire_feature_akaire_file_path(
        akaireFileId,
        { page_id: currentPageId, animation_1: checkedOption[0].value, animation_2: checkedOption[1].value }
      )
    }
  }

  checkIsCompareScreen = () => {
    const { showMode } = this.props;
    return showMode == 'compare'
  }

  onError = (element) => {
    element.onerror = null;
    element.src = gon.assets.default_loading_thumbnail;
  }

  isNotShowCommentAndDeletePage = (props) => {
    return props.data.value === '' && props.data.label === '該当ページはありません。';
  }

  render() {
    const { pages, currentPageId, role, deletePage,
      currentAnimation, onClickFinalizeAnimation, onClickCancelFinalAnimation, akaireFileName,
      name, currentAnimationTotalSize, animations, page_last_animation, projectType, mobile, isOffAllFinalPage,
      onChangeIsOffAllFinalPage } = this.props;
    const { shouldShowEditForm, shouldShowAddPageSuccess, valueForm } = this.state;
    const colorPTag = canCreateAndUpdatePage(role) ? '#fff' : '#878d92';
    const message_confirm = '指定ページの全てのバージョンが削除されます。宜しいですか？';
    const stylePTag = {
      marginBottom: '0',
      color: `${colorPTag}`
    }
    const dFlexItemsCenter = {
      display: 'flex',
      alignItems: 'center'
    }
    const iconDeleteStyle = {
      color: 'white',
      marginLeft: '10px',
      cursor: 'pointer',
      width: '14px',
      height: '18px',
      marginBottom: '-2px',
    }
    const versionTypeIconStyle = {
      color: 'white',
      marginLeft: '0px',
      width: mobile ? '22px' : 'fit-width',
      height: mobile ? '18px' : '18px',
      marginBottom: '0px',
      marginRight: '4px',
      objectFit: mobile ? 'contain' : 'initial',
      flex: mobile ? '0 0 22px' : '0 0 auto'
    }
    const iconCompareVersionStyle = {
      color: 'white',
      marginLeft: '0px',
      width: '24px',
      height: 'auto',
      marginBottom: '3px',
      marginRight: '4px',
    }
    const labelPageNameStyle = {
      color: 'white',
      whiteSpace: 'nowrap',
      marginRight: '5px'
    }
    const styleIconEditWhenCantUpdate = {
      marginLeft: '10px',
      color: 'white',
      width: '19px',
      height: '20px'
    }
    const styleImgThumbnailVersion = {
      height: '34px',
      width: '50px',
      borderRadius: '5px',
      border: '1px solid #707070'
    }
    const shrinkableContentStyle = {
      minWidth: 0,
    }

    const { Option } = components;
    const pageOption = props => (
      <Option {...props}>
        <div className={`d-flex justify-content-space-between align-items-center pd-page ${props.data.value == this.defaultPage().value ? 'high-light-page' : ''}`}>
          <p className='react-select-option page-option option_white'> {props.data.label} { props.data.value == this.defaultPage().value ? '（現在表示中のページ）' : '' } </p>
          {canCreateCommentPublicUser(role) && !this.isNotShowCommentAndDeletePage(props) && (
            <div className='d-flex'>
              <img src={iconPen} style={styleIconEdit} onClick={canCreateAndUpdatePage(role) ? (event) => this.open(event, props.data) : null} />
              {canDeletePage(role) && pages.length > 1 && !this.checkIsCompareScreen() ? <img onClick={(event) => { this.confirmDeletePage(props.data); event.stopPropagation(); }} src={iconBinWhite} style={iconDeleteStyle} /> : ''}
            </div>
          )}
        </div>
      </Option>
    );

    const versionMenu = props => (
      <Fragment>
        <components.Menu {...props}>
          {props.children}
          {!mobile && (
            <div className='compare-version-actions'>
              <button className="button-compare-version font-weight-bold disabled" onClick={() => {this.submitCompareVersion(); }} onTouchStart={(event) => {this.submitCompareVersion(); event.stopPropagation();}}>
                <img src={compareVersion} style={iconCompareVersionStyle} /> Show version
              </button>
              <div className='alert-more-than-two-option d-none'>2個まで選択できます。</div>
            </div>
          )}
        </components.Menu>
      </Fragment>
    )

    const renderVersionPrimaryInfo = (data, isCompact = false) => {
      if (data.keep_comment) return null;

      const textClassName = isCompact
        ? 'text-primary text-ellipsis d-inline-block version-file-text'
        : `text-primary text-ellipsis ${this.checkFinalVersion() ? 'max-width-90px' : 'max-width-100px'} d-inline-block`;

      if (data.video_embed) {
        return (
          <>
            <img src={iconYoutube} style={versionTypeIconStyle} />
            <a className={`text-underline ${textClassName}`} target='_blank' href={data.url_capture}>{data.fileName}</a>
            {data.duration ? <span className='version-duration'>| {data.duration}</span> : null}
          </>
        );
      }

      if (data.video_upload) {
        return (
          <>
            <img src={iconVideo} style={versionTypeIconStyle} />
            <span className={textClassName}>{data.fileName !== undefined ? data.fileName : ''}</span>
            {data.duration ? <span className='version-duration'>| {data.duration}</span> : null}
          </>
        );
      }

      if (data.url_capture !== null) {
        return (
          <>
            <img src={iconWeb} style={versionTypeIconStyle} />
            <a className={`text-underline ${textClassName}`} target='_blank' href={data.url_capture}>{data.url_capture}</a>
          </>
        );
      }

      return (
        <>
          <img src={iconPDF} style={versionTypeIconStyle} />
          <span className={textClassName}>{data.fileName}</span>
        </>
      );
    }

    const versionOption = props => (
      <Fragment>
        <components.Option {...props}>
          <div className={`d-flex justify-content-space-between align-items-center pd-version ${props.data.value === this.defaultVersion().value ? 'high-light-version' : ''}`}>
            <div className={`w-100 ${mobile ? 'version-option-body-mobile' : 'd-flex justify-content-space-between align-items-center'}`} style={shrinkableContentStyle}>
              {!mobile && (
                <input type="checkbox" className="checkbox-compare" value={props.data.value} onClick={(event) => {this.onCheckCompareVersion(props.data.value); event.stopPropagation(); }} disabled={props.data.disabled} />
              )}
              <p className={`react-select-option version-title ${this.checkFinalVersion() ? 'version-final' : '' }`}>{props.data.label == '最終稿' ? '最終稿' : `${props.data.label}`}</p>
              <img className='mx-1' src={props.data.set_thumbnail ? props.data.set_thumbnail : imgDefaultThumbnail} alt='thumbnail' style={styleImgThumbnailVersion} onError={({ currentTarget }) => this.onError(currentTarget)} />
              <div className={`version-info ${mobile ? 'version-info-mobile' : ''}`} style={shrinkableContentStyle}>
                <p className={`react-select-option align-items-center ${mobile ? 'version-file-row' : `${this.checkFinalVersion() ? 'w-200px' : 'w-230px'} d-flex`}`}>
                  {renderVersionPrimaryInfo(props.data, mobile)}
                </p>
                <p className={`react-select-option d-flex align-items-center ${mobile ? 'version-meta-row' : ''}`}>
                  <span className={`text-ellipsis ${mobile ? 'version-creator-mobile' : (this.checkFinalVersion() ? 'max-width-80px' : 'max-width-95px')}`}>{props.data.creatorName}</span>
                  <span className='version-meta-separator'>：</span>
                  <span className={mobile ? 'text-ellipsis version-created-at-mobile' : ''}>{props.data.createdAt}</span>
                </p>
              </div>
            </div>
            {
              !this.checkIsCompareScreen() && <img className='delete-version'
                onClick={(event) => { this.confirmDeleteVersion(props.data.value); event.stopPropagation(); }}
                src={iconBin} style={iconDeleteStyle} />
            }
          </div>
          <div className='border'> </div>
        </components.Option>
      </Fragment>
    );
    const pagesToOptions = this.pagesToOptions();
    const animationsToOptions = this.animationsToOptions();
    const styleIconEdit = canCreateAndUpdatePage(role) ? Object.assign({ cursor: 'pointer' }, styleIconEditWhenCantUpdate) : styleIconEditWhenCantUpdate
    const page = pages.find(_ => _.id == currentPageId)
    const canUpdateAnimation = canCreateAnimation(role, animations);
    return (
      <div className={`d-flex page-control flex-basis-100 ${mobile ? 'mobile' : 'justify-content-space-between'} `}>
        {/* {
          !mobile ? (
            <p className="text-header set-final">
              {
                !canUserNotPermission(role) && currentAnimation && !mobile && role !== 'reader' ? (
                  currentAnimation.final ? (
                    <a className="text-light" style={{ textDecoration: 'underline' }} onClick={onClickCancelFinalAnimation} href="javascript:void(0);">
                      { this.checkIsCompareScreen()
                        ? 'Verの最終稿を解除する'
                        : 'バージョンの最終稿を解除する'
                      }
                    </a>
                  ) : role != 'public_visitor' ? (
                    <a className="text-light" style={{ textDecoration: 'underline' }} onClick={onClickFinalizeAnimation} href="javascript:void(0);">
                      { this.checkIsCompareScreen()
                        ? '表示中のVerを最終稿にする'
                        : '表示中のバージョンを最終稿にする'
                      }
                    </a>
                  ) : ''
                ) : ''
              }
            </p>
          ) : ''
        } */}
        <div id="page-selector" style={dFlexItemsCenter} className='page-select'>
          {/* <span style={labelPageNameStyle}>ページ名</span> */}
          <Select
            isSearchable={ false }
            id="select-current-page-animation"
            className={`page-control-select ${mobile ? 'mobile' : ''}`}
            options={pagesToOptions}
            onChange={(event) => this.onChangePageSelf(event)}
            styles={this.customSelectStyle(true)}
            components={{
              IndicatorSeparator: () => null,
              Option: pageOption,
            }}
            value={this.defaultPage()}
            noOptionsMessage={() => null}
          />

          <Select
            isSearchable={ false }
            id="animation-selector"
            className={'version-control-select'}
            isDisabled={!canUpdateAnimation}
            options={animationsToOptions}
            onChange={this.onChangeAnimationSelect}
            styles={this.customSelectStyle(false)}
            hideSelectedOptions={false}
            components={{
              IndicatorSeparator: () => null,
              Menu: versionMenu,
              Option: versionOption
            }}
            ref={(ref) => this.selectAnimationRef = ref}
            value={this.defaultVersion()}
            noOptionsMessage={() => null}
          />

          { canUpdateAnimation && mobile && (
            <FormGroup check className="d-flex align-items-center w-100"
              style={{ maxWidth: '70px', marginTop: '-11px', marginLeft: '-9px', justifyContent: 'end' }}>
              <Input type="checkbox" className="mr-1 mt-0 ml-0 cursor-pointer"
              style={{ width: '10px', height: '10px', position: 'static', transform: 'scale(2.1)' }} checked={isOffAllFinalPage} onChange={onChangeIsOffAllFinalPage} />
              <span className="text-of-input-check text-white text-checkbox-final" style={{ marginLeft: '6px', fontSize: '10px' }}>
                最終稿<br />は除外
              </span>
            </FormGroup>
          )}

          {/* <img src={iconPen} style={styleIconEdit} onClick={canCreateAndUpdatePage(role) ? this.open.bind(this, 'EditForm') : null} />
          { canDeletePage(role) ? <img onClick={() => {this.confirmDeletePage() }} src={iconBin} style={iconDeleteStyle} /> : '' } */}
        </div>
        <Modal id="page-edit-name-modal" isOpen={shouldShowEditForm} animation={false} className={'modal-dialog-centered modal-style confirm-submit-modal'} contentClassName={'text-center'}
          toggle={this.handleOutSideClick}>
          <Form onSubmit={this.submitForm}>
            <ModalBody>
              <h5 className="modal-title white-text">ページ名を変更する</h5>
              <Input type="text" className="mt-2 mb-3 max-width-400px m-0-auto" value={valueForm} autoFocus onChange={event => this.changeName(event)} />
              <Button type='submit' className="btn btn-primary ml-2" color='primary'>変更する</Button>
            </ModalBody>
          </Form>
        </Modal>

        <Modal id="modalAkaireAddPageSuccess" isOpen={shouldShowAddPageSuccess} animation={false} className={'modal-dialog-centered modal-style confirm-submit-modal'} contentClassName={'text-center'}
          toggle={this.closePopupAddPageSuccess}>
          <ModalBody>
            {
              currentAnimation?.need_conversion ? (
                <div>
                  <span class="font-weight-bold">
                    {(currentAnimation?.additional_info?.gdrive_pdf || currentAnimation?.is_pdf) ? 'PDFデータアップロードを開始しました。' : '動画データアップロードを開始しました。'}
                  </span>
                  <br/>
                  <span class="message-pdf-upload">
                    ※ご登録のメールアドレス宛にアップロード完了通知が届きます。
                  </span>
                  <br/>
                  ※ファイル容量によってはアップロードに時間が掛かる場合がございます。
                </div>
              ) : (
                <div>
                  <p className='mb-0'>{`${akaireFileName} の`}</p>
                  <p className='mb-0'>{`${page?.title}にVer.${animations[0]?.title}を保存しました。`}</p>
                  {this.linkOpenEditPage(page)} <br />
                  <Button type='button' onClick={this.closePopupAddPageSuccess} className="btn btn-primary mt-2" color='primary'>OK</Button>
                </div>
              )
            }
          </ModalBody>
        </Modal>
      </div>
    )
  }
}
